"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailAddressParser = void 0;
const state_1 = require("./state");
const token_1 = require("./token");
class EmailAddressParser {
    get isValidHostnameWithDot() {
        return this.hostnamePostDotChars >= 2;
    }
    constructor(options) {
        this.currentState = state_1.State.StartOfLocalPart;
        this.value = '';
        this.localPartSize = 0;
        this.hostNameSize = 0;
        this.hostnamePostDotChars = 0;
        this.options = Object.assign({
            disallowTldAsHostname: false,
            disallowIpAddresses: false,
            disallowQuotedStrings: false,
        }, options !== null && options !== void 0 ? options : {});
    }
    isValid(address) {
        if (!address) {
            return false;
        }
        this.value = address;
        this.currentState = state_1.State.StartOfLocalPart;
        this.localPartSize = 0;
        this.hostNameSize = 0;
        while (true) {
            if (this.localPartSize > 64) {
                return false;
            }
            if (this.hostNameSize > 255) {
                return false;
            }
            switch (this.currentState) {
                case state_1.State.StartOfLocalPart:
                    this.startOfLocalPart();
                    break;
                case state_1.State.InQuote:
                    this.inQuote();
                    break;
                case state_1.State.AfterQuote:
                    this.afterQuote();
                    break;
                case state_1.State.AfterDot:
                    this.afterDot();
                    break;
                case state_1.State.AfterBackslash:
                    this.afterBackslash();
                    break;
                case state_1.State.OutsideQuote:
                    this.outsideQuote();
                    break;
                case state_1.State.StartOfDomain:
                    this.startOfDomain();
                    break;
                case state_1.State.InIpv6Address:
                    this.inIpv6Address();
                    break;
                case state_1.State.InIpv4Address:
                    this.inIpv4Address();
                    break;
                case state_1.State.InHostname:
                    this.inHostname();
                    break;
                case state_1.State.HostnameAfterDot:
                    this.hostnameAfterDot();
                    break;
                case state_1.State.HostnameAfterHyphen:
                    this.hostnameAfterHyphen();
                    break;
                case state_1.State.EndOfDomain:
                    return this.value.length == 0;
                case state_1.State.Error:
                    return false;
                default:
                    throw new Error('Invalid state.');
            }
        }
    }
    getToken() {
        if (!this.value.length) {
            return token_1.Token.EOF;
        }
        const c = this.value[0];
        this.value = this.value.substring(1);
        if (c == '"') {
            return token_1.Token.Quote;
        }
        if (c == '.') {
            return token_1.Token.Dot;
        }
        if (c == '@') {
            return token_1.Token.At;
        }
        if (c == '\\') {
            return token_1.Token.Backslash;
        }
        if (EmailAddressParser.AlphaRegex.test(c)) {
            return token_1.Token.Alpha;
        }
        if (EmailAddressParser.NumeralRegex.test(c)) {
            return token_1.Token.Numeral;
        }
        if (c == '-') {
            return token_1.Token.Hyphen;
        }
        if (EmailAddressParser.PrintableChars.includes(c)) {
            return token_1.Token.OtherPrintable;
        }
        if (c == '[') {
            return token_1.Token.LeftSquareBracket;
        }
        if (c == ']') {
            return token_1.Token.RightSquareBracket;
        }
        if (EmailAddressParser.EscapableChars.includes(c)) {
            return token_1.Token.Escapable;
        }
        return token_1.Token.Invalid;
    }
    startOfLocalPart() {
        const token = this.getToken();
        switch (token) {
            case token_1.Token.Quote:
                if (this.options.disallowQuotedStrings) {
                    this.currentState = state_1.State.Error;
                    return;
                }
                this.currentState = state_1.State.InQuote;
                this.localPartSize += 1;
                return;
            case token_1.Token.Alpha:
            case token_1.Token.Numeral:
            case token_1.Token.Hyphen:
            case token_1.Token.OtherPrintable:
                this.localPartSize += 1;
                this.currentState = state_1.State.OutsideQuote;
                return;
            default:
                this.currentState = state_1.State.Error;
                return;
        }
    }
    inQuote() {
        const token = this.getToken();
        switch (token) {
            case token_1.Token.Quote:
                this.currentState = state_1.State.AfterQuote;
                this.localPartSize += 1;
                return;
            case token_1.Token.Dot:
            case token_1.Token.At:
            case token_1.Token.Alpha:
            case token_1.Token.Numeral:
            case token_1.Token.Hyphen:
            case token_1.Token.OtherPrintable:
            case token_1.Token.Escapable:
            case token_1.Token.LeftSquareBracket:
            case token_1.Token.RightSquareBracket:
                this.currentState = state_1.State.InQuote;
                this.localPartSize += 1;
                return;
            case token_1.Token.Backslash:
                this.currentState = state_1.State.AfterBackslash;
                this.localPartSize += 1;
                return;
            default:
                this.currentState = state_1.State.Error;
                return;
        }
    }
    afterQuote() {
        const token = this.getToken();
        switch (token) {
            case token_1.Token.At:
                this.currentState = state_1.State.StartOfDomain;
                return;
            default:
                this.currentState = state_1.State.Error;
                return;
        }
    }
    afterDot() {
        const token = this.getToken();
        switch (token) {
            case token_1.Token.Alpha:
            case token_1.Token.Numeral:
            case token_1.Token.Hyphen:
            case token_1.Token.OtherPrintable:
                this.currentState = state_1.State.OutsideQuote;
                this.localPartSize += 1;
                return;
            default:
                this.currentState = state_1.State.Error;
                return;
        }
    }
    afterBackslash() {
        const _token = this.getToken();
        this.localPartSize += 1;
        this.currentState = state_1.State.InQuote;
    }
    outsideQuote() {
        const token = this.getToken();
        switch (token) {
            case token_1.Token.Dot:
                this.currentState = state_1.State.AfterDot;
                this.localPartSize += 1;
                return;
            case token_1.Token.At:
                this.currentState = state_1.State.StartOfDomain;
                return;
            case token_1.Token.Alpha:
            case token_1.Token.Numeral:
            case token_1.Token.Hyphen:
            case token_1.Token.OtherPrintable:
                this.localPartSize += 1;
                this.currentState = state_1.State.OutsideQuote;
                return;
            default:
                this.currentState = state_1.State.Error;
                return;
        }
    }
    startOfDomain() {
        if (this.value.startsWith("[IPv6:")) {
            if (this.options.disallowIpAddresses) {
                this.currentState = state_1.State.Error;
                return;
            }
            this.value = this.value.substring(6);
            this.currentState = state_1.State.InIpv6Address;
            return;
        }
        const token = this.getToken();
        switch (token) {
            case token_1.Token.LeftSquareBracket:
                this.currentState = this.options.disallowIpAddresses ? state_1.State.Error : state_1.State.InIpv4Address;
                return;
            case token_1.Token.Alpha:
            case token_1.Token.Numeral:
                this.currentState = state_1.State.InHostname;
                this.hostNameSize += 1;
                return;
            default:
                this.currentState = state_1.State.Error;
                return;
        }
    }
    inHostname() {
        const token = this.getToken();
        if (token === token_1.Token.Alpha && this.hostnamePostDotChars > 0) {
            this.hostnamePostDotChars += 1;
        }
        else if (token !== token_1.Token.EOF) {
            this.hostnamePostDotChars = 0;
        }
        switch (token) {
            case token_1.Token.Dot:
                this.currentState = state_1.State.HostnameAfterDot;
                this.hostNameSize += 1;
                return;
            case token_1.Token.Alpha:
            case token_1.Token.Numeral:
                this.currentState = state_1.State.InHostname;
                this.hostNameSize += 1;
                return;
            case token_1.Token.Hyphen:
                this.currentState = state_1.State.HostnameAfterHyphen;
                this.hostNameSize += 1;
                return;
            case token_1.Token.EOF:
                this.currentState = !this.options.disallowTldAsHostname || this.isValidHostnameWithDot ? state_1.State.EndOfDomain : state_1.State.Error;
                return;
            default:
                this.currentState = state_1.State.Error;
                return;
        }
    }
    hostnameAfterDot() {
        const token = this.getToken();
        this.hostnamePostDotChars = 1;
        switch (token) {
            case token_1.Token.Alpha:
            case token_1.Token.Numeral:
                this.currentState = state_1.State.InHostname;
                this.hostNameSize += 1;
                return;
            default:
                this.currentState = state_1.State.Error;
                return;
        }
    }
    hostnameAfterHyphen() {
        const token = this.getToken();
        switch (token) {
            case token_1.Token.Dot:
                this.currentState = state_1.State.HostnameAfterDot;
                this.hostNameSize += 1;
                return;
            case token_1.Token.Alpha:
            case token_1.Token.Numeral:
                this.currentState = state_1.State.InHostname;
                this.hostNameSize += 1;
                return;
            case token_1.Token.Hyphen:
                this.currentState = state_1.State.HostnameAfterHyphen;
                this.hostNameSize += 1;
                return;
            default:
                this.currentState = state_1.State.Error;
                return;
        }
    }
    inIpv4Address() {
        try {
            const split = this.value.substring(0, this.value.length - 1).split('.');
            this.value = this.value.substring(this.value.length - 1);
            if (split.length != 4) {
                this.currentState = state_1.State.Error;
                return;
            }
            let asInt;
            for (const segment of split) {
                asInt = parseInt(segment, 10);
                if (isNaN(asInt) || asInt < 0 || asInt > Math.pow(2, 8)) {
                    this.currentState = state_1.State.Error;
                    return;
                }
            }
            const lastToken = this.getToken();
            if (lastToken != token_1.Token.RightSquareBracket) {
                this.currentState = state_1.State.Error;
                return;
            }
            this.currentState = state_1.State.EndOfDomain;
        }
        catch (_) {
            this.currentState = state_1.State.Error;
        }
    }
    inIpv6Address() {
        try {
            const split = this.value.substring(0, this.value.length - 1).split(':');
            this.value = this.value.substring(this.value.length - 1);
            if (split.length != 8) {
                this.currentState = state_1.State.Error;
                return;
            }
            let asInt;
            for (const segment of split) {
                if (segment.length != 4) {
                    this.currentState = state_1.State.Error;
                    return;
                }
                asInt = parseInt(segment, 16);
                if (isNaN(asInt) || asInt < 0 || asInt >= Math.pow(2, 16)) {
                    this.currentState = state_1.State.Error;
                    return;
                }
            }
            const lastToken = this.getToken();
            if (lastToken != token_1.Token.RightSquareBracket) {
                this.currentState = state_1.State.Error;
                return;
            }
            this.currentState = state_1.State.EndOfDomain;
        }
        catch (_) {
            this.currentState = state_1.State.Error;
        }
    }
}
exports.EmailAddressParser = EmailAddressParser;
EmailAddressParser.AlphaRegex = /[a-zA-Z]/;
EmailAddressParser.NumeralRegex = /[0-9]/;
EmailAddressParser.PrintableChars = [
    '!',
    '#',
    '$',
    '%',
    '&',
    '\'',
    '*',
    '+',
    '/',
    '=',
    '?',
    '^',
    '_',
    '`',
    '{',
    '|',
    '}',
    '~',
];
EmailAddressParser.EscapableChars = [
    ' ',
    '\"',
    '(',
    ')',
    ',',
    ':',
    ';',
    '<',
    '>',
    '\t',
];
//# sourceMappingURL=parser.js.map